import {
  extractCashbackCouponsFromItem,
  sortByImmediateCashbacks
} from '@epilot/journey-logic-commons'
import type { PricingDetails } from '@epilot/pricing'
import { useMemo } from 'react'

export const useExtractCouponsFromPricingDetails = (
  pricingDetails: PricingDetails
) => {
  return useMemo(() => {
    const [firstItem] = pricingDetails.items ?? []

    if (!firstItem) {
      return []
    }

    /**
     * We only want to display the coupons from simple prices,
     * if they result in a discount OR cashback being applied
     */
    if (
      (typeof firstItem.discount_amount === 'number' &&
        firstItem.discount_amount > 0) ||
      (typeof firstItem.cashback_amount === 'number' &&
        firstItem.cashback_amount > 0)
    ) {
      return firstItem._coupons ?? []
    }

    /**
     * If we're dealing with a composite price item,
     * we want to display the cashback coupons from all item_components and the item itself
     */
    const cashbackCoupons = sortByImmediateCashbacks(
      pricingDetails.items?.flatMap((item) =>
        extractCashbackCouponsFromItem(item)
      ) ?? []
    )

    return cashbackCoupons
  }, [pricingDetails.items])
}
